// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/event-list/event-list.component.scss
// module id = 270
// module chunks = 0